import { AutoCorrectModelPublisher } from './AutoCorrectModelPublisher.js';
import { AutoCorrectModelEvents } from './AutoCorrectModelEvents.js';
export class EngineNotificationsService {
    constructor() {
        this.listeners = new Map();
        this.autoCorrectModelPublisher = new AutoCorrectModelPublisher(this);
        this.autoCorrectModelEvents = new AutoCorrectModelEvents(this);
    }
    notify(eventName, event) {
        const listeners = this.listeners.get(eventName);
        if (listeners) {
            listeners.forEach(listener => listener(event));
        }
    }
    subscribe(eventName, listener) {
        let listeners = this.listeners.get(eventName);
        if (listeners == undefined) {
            listeners = [];
        }
        listeners.push(listener);
        this.listeners.set(eventName, listeners);
        return () => {
            const index = listeners.findIndex(l => l === listener);
            if (index >= 0) {
                listeners.splice(index, 1);
            }
        };
    }
}
//# sourceMappingURL=EngineNotificationsService.js.map